/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TherapistSetupIntentResponse = {
    intendedMeetingProvider?: string | null;
    meetingConnectDeclined: boolean;
    intendedCalendarProvider?: string | null;
    calendarConnectDeclined: boolean;
    widgetIntent?: TherapistSetupIntentResponse.widgetIntent | null;
    bookingSiteIntent?: TherapistSetupIntentResponse.bookingSiteIntent | null;
    clientPortalIntent?: TherapistSetupIntentResponse.clientPortalIntent | null;
    paymentMethodSetupPending: boolean;
    accountingConnectSetupPending: boolean;
    dismissedTaskIds: Array<string>;
    completedFeatureWizardIds: Array<string>;
};
export namespace TherapistSetupIntentResponse {
    export enum widgetIntent {
        NO = 'no',
        YES = 'yes',
        LATER = 'later',
    }
    export enum bookingSiteIntent {
        NO = 'no',
        YES = 'yes',
    }
    export enum clientPortalIntent {
        NO = 'no',
        YES = 'yes',
        AUTO = 'auto',
    }
}

